/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-env browser */
import classNames from 'classnames'
import * as React from 'react'

import slug from 'slug'
import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const striptags = require('striptags')

const PubSub = require('../../../../client/clientjs/services/pub-sub')
const CatchesGrid = require('../CatchesGrid/Grid')
const UsersGrid = require('../UsersGrid/Grid')
const GearsGrid = require('./GearsGrid')
const SpeciesList = require('./SpeciesList')
const CatchMethodsList = require('./CatchMethodsList')

function getTabsToDisplay(tabs, currentlySelectedKey) {
  return (tabs || [])
    .filter(tab => tab.tabKey !== currentlySelectedKey)
    .sort((a, b) => a.sideCardPosition - b.sideCardPosition)
}

function goToTab(e, card) {
  if (!card || !card.tabKey) {
    return true
  }
  if (e) {
    e.preventDefault()
  }
  PubSub.pub('scrollableCoverCardClick', { tabKey: card.tabKey, longTitle: card.longTitle })
  return false
}

const getUsersGrid = (props, appConfig) => (
  <div className="animated fadeIn faster">
    <UsersGrid
      appConfig={appConfig}
      users={(props.usersExtract || []).slice(0, 9)}
      simpleGrid
      customItemClassName="is-4 is-size-8"
    />
  </div>
)

const getGearsGrid = (props, appConfig) => {
  const { gearExtract } = props
  return (
    <div className="animated fadeIn faster">
      <GearsGrid
        appConfig={appConfig}
        gears={(gearExtract || []).slice(0, 6)}
        simpleGrid
        customItemClassName="is-6 is-size-8"
      />
    </div>
  )
}

const getSpeciesList = (props, appConfig) => {
  const { speciesExtract } = props
  return (
    <div className="animated fadeIn faster">
      <SpeciesList
        appConfig={appConfig}
        species={(speciesExtract || []).slice(0, 3)}
        customItemClassName="is-6 is-size-8"
      />
    </div>
  )
}

const getCatchMethodsList = (props, appConfig) => {
  const { catchMethodsExtract } = props
  return (
    <div className="animated fadeIn faster">
      <CatchMethodsList
        appConfig={appConfig}
        catchMethods={(catchMethodsExtract || []).slice(0, 3)}
        customItemClassName="is-6 is-size-8"
      />
    </div>
  )
}

const getMapSideCard = (props, _appConfig, card) => (
  <div />
  /*
  <div className="animated fadeIn faster">
    {props.targetUrl ? (
      <a href={props.targetUrl} title={card.texts.title}>
        <img
          src="https://res.cloudinary.com/fishfriender/image/upload/v1547578177/statics/placeholders/world_map_grey.png"
          className="has-object-fit-cover"
          alt=""
        />
      </a>
    ) : (
      <img
        src="https://res.cloudinary.com/fishfriender/image/upload/v1547578177/statics/placeholders/world_map_grey.png"
        className="has-object-fit-cover"
        alt=""
      />
    )}
  </div>
  */
)

const getMapPremiumIncentive = (props, _appConfig, card, { translate }) => {
  let isIOSiwebview = false
  let isAndroidWebview = false
  try {
    isIOSiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)
    isAndroidWebview = navigator.userAgent.includes('wv')
  } catch (e) {
    // do nothing
  }
  return (
    <div className="animated fadeIn faster">
      <div>
        <p className="is-size-5 has-text-bold">{translate('sideCards.mapPremiumIncentive.title')}</p>
        <p className="is-size-7 has-padding-bottom-small">{translate('sideCards.mapPremiumIncentive.subtitle')}</p>
      </div>
      <div className="columns is-multiline is-centered has-padding-top-small">
        <div className="column is-half-desktop is-full" style={{ display: isAndroidWebview ? 'none' : 'block' }}>
          <a
            className="badge-store badge-app-store"
            href={props.appStoreUrl}
            target="_blank"
            data-analytics-event="BADGE_APP_STORE"
            rel="noreferrer"
          >
            <img data-src={props.appStoreBadgeSrc} alt="AppStore" className="lazyload" />
          </a>
        </div>
        <div className="column is-half-desktop is-full" style={{ display: isIOSiwebview ? 'none' : 'block' }}>
          <a
            className="badge-store badge-play-store"
            target="_blank"
            href={props.playStoreUrl}
            data-analytics-event="BADGE_PLAY_STORE"
            rel="noreferrer"
          >
            <img data-src={props.playStoreBadgeSrc} alt="PlayStore" className="lazyload" />
          </a>
        </div>
      </div>
      <img
        src="https://statics.fishfriender.com/statics/scale-features/spots-map-screenshot.png"
        style={{ width: '100%' }}
        className="has-object-fit-cover"
        alt=""
      />
    </div>
  )
}

const getListSideCard = (rows, icon) => (
  <div className="animated fadeIn faster">
    <p className="is-size-7">
      <ul>
        {rows.map(elt => (
          <li key={elt.key}>
            <a href={elt.pageUrl} title={elt.title}>
              <span className="icon has-text-info">
                <i className={icon} />
              </span>
              <span>{elt.title}</span>
            </a>
          </li>
        ))}
      </ul>
    </p>
  </div>
)

const COMPONENTS = {
  raw: (props, appConfig, card, opts) => {
    let { content } = props
    if (!card.linkPath) {
      return (
        <div className="content is-size-7">
          <div className="animated fadeIn faster" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      )
    }
    const maxLength = 200
    if (content.length > maxLength) {
      content = `${striptags(content, ['strong', 'b', 'br', 'ul', 'li']).substring(0, maxLength - 3)}...`
    }
    return (
      <a href={card.linkPath} title={card.texts.title} onClick={opts.goToTab}>
        <div className="content is-size-7">
          <div className="animated fadeIn faster" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </a>
    )
  },
  catchesGrid: (props, appConfig) => (
    <div className="animated fadeIn faster">
      <CatchesGrid
        userSettings={appConfig.userSettings}
        locale={appConfig.locale.identifierShort}
        isLoggedIn={appConfig.isLoggedIn}
        catches={(props.catches || []).slice(0, 9)}
        displayLikes={false}
        simpleGrid
        customItemClassName="is-4 is-size-8"
      />
    </div>
  ),
  usersGrid: getUsersGrid,
  bestGears: getGearsGrid,
  gearsByCategories: getGearsGrid,
  filteredGearGrid: getGearsGrid,
  userCatchesMap: getMapSideCard,
  goToMap: undefined, // getMapSideCard,
  gearBySpecies: getSpeciesList,
  hydroSpecies: getSpeciesList,
  hydroCatchMethods: getCatchMethodsList,
  boundariesList: props =>
    getListSideCard(
      props.boundariesExtract.map(elt => ({
        key: elt.boundaryOsmId,
        pageUrl: elt.pageUrl,
        title: elt.boundaryName,
      })),
      'far fa-map-pin'
    ),
  watersList: props =>
    getListSideCard(
      props.watersExtract.map(elt => ({
        key: `${elt.name}-${elt.boundaryName}-${elt.boundaryOsmId}`,
        pageUrl: elt.pageUrl,
        title: `${elt.name}, ${elt.boundaryName}`,
      })),
      'far fa-water'
    ),
  businesses: props =>
    getListSideCard(
      props.businessesExtract.map(elt => ({
        key: elt.id,
        pageUrl: `/businesses/${elt.id}`,
        title: elt.name,
      })),
      'far fa-building'
    ),
  fishingTrailsList: (props, appConfig, tabToRender, { translate }) =>
    getListSideCard(
      props.fishingTrails.slice(0, props.limit ?? 3).map(elt => ({
        key: `${elt.id}-${elt.name}`,
        pageUrl: `/spots/${slug(elt.name)}-${elt.id}`,
        title: elt.name + (elt.trailType ? ` - ${translate(`hydro.fishingTrails.trailTypes.${elt.trailType}`)}` : ''),
      })),
      'far fa-map-pin'
    ),
  mapPremiumIncentive: getMapPremiumIncentive,
}

class SideCardsContainer extends React.Component {
  constructor(props) {
    super(props)
    const currentlySelectedTabKey = ((props.sideCards || []).find(t => t.isContentActive) || {}).tabKey
    this.state = {
      tabsToDisplay: getTabsToDisplay(props.sideCards, currentlySelectedTabKey),
    }
  }

  componentDidMount() {
    const { sideCards } = this.props
    this.eventId = PubSub.sub('scrollableCoverTabClick', ({ args }) => {
      this.setState({
        tabsToDisplay: getTabsToDisplay(sideCards, args.tabKey),
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState(oldState => ({
      tabsToDisplay: getTabsToDisplay(nextProps.sideCards, oldState.currentlySelectedTabKey),
    }))
  }

  componentWillUnmount() {
    PubSub.unsub('scrollableCoverTabClick', this.eventId)
  }

  render() {
    const { tabsToDisplay } = this.state
    const { appConfig, translate } = this.props

    return (
      <div>
        {tabsToDisplay.map((tabToRender, index) => {
          const componentToRender = COMPONENTS[tabToRender.type]
          if (!componentToRender) {
            console.error('No component found for sidecard !', tabToRender)
            return <span key={tabToRender.key || tabToRender.tabKey || `${index}`} />
          }
          return (
            <div
              key={tabToRender.key || tabToRender.tabKey || `${index}`}
              className={classNames('content-card', 'side-cards-container', { 'has-margin-top-small': index > 0 })}
            >
              <div className="columns is-mobile is-multiline">
                {!tabToRender.hideCardTitle && (
                  <p className="column is-size-7 has-text-weight-bold has-text-primary-blue has-padding-bottom-zero">
                    {tabToRender.texts.title}
                  </p>
                )}
                {tabToRender.linkPath && (
                  <a
                    href={tabToRender.linkPath}
                    onClick={e => goToTab(e, tabToRender)}
                    alt={tabToRender.texts.title}
                    title={tabToRender.texts.title}
                    className="column is-narrow is-size-7 has-padding-bottom-zero"
                  >
                    {translate('sideCards.seeAll')}
                  </a>
                )}
                <div className="column is-12">
                  {componentToRender(tabToRender.props, appConfig, tabToRender, {
                    translate,
                    goToTab: e => goToTab(e, tabToRender),
                  })}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

SideCardsContainer.propTypes = {
  translate: PropTypes.func.isRequired,
  appConfig: PropTypes.object.isRequired,
  sideCards: PropTypes.array,
}

SideCardsContainer.defaultProps = {
  sideCards: [],
  currentlySelectedTabKey: null,
}

module.exports = withTranslator(SideCardsContainer)
